(() => {
  function init() {
    if (window.matchMedia('(min-width: 750px)').matches || document.querySelector('.one-life-sticky-cta')) return;
    const form = document.querySelector('product-form form');
    const original = form?.querySelector('.product-form__submit');
    if (!form || !original) return;
    const bar = document.createElement('div');
    bar.className = 'one-life-sticky-cta';
    bar.innerHTML = '<span class="one-life-sticky-cta__price" aria-live="polite"></span><button type="button" class="button">Add to cart</button>';
    document.body.append(bar);
    const price = bar.querySelector('.one-life-sticky-cta__price');
    const button = bar.querySelector('button');
    const update = () => {
      const priceNode = document.querySelector('.price .price-item--sale, .price .price-item--regular');
      price.textContent = priceNode?.textContent?.trim() || '';
      button.disabled = original.disabled;
      button.textContent = original.disabled ? 'Unavailable' : 'Add to cart';
      bar.classList.toggle('is-disabled', original.disabled);
    };
    button.addEventListener('click', () => original.click());
    form.addEventListener('change', update);
    const observer = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 240);
    }, { threshold: 0.15 });
    observer.observe(original);
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();